import { QueryFn } from '@percent/education-hosted-form/hooks/useQuery/useQuery.types'
import { GetOrganisationParams, GetOrganisationsResponse } from './organisations.types'

export const searchOrganisationsAction: QueryFn<[string, GetOrganisationParams], GetOrganisationsResponse> = async (
  client,
  [_, args]
) => {
  const response = await client.get(`v1/organisations`, { params: args })

  return response.data
}
